var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98312 2.94458C12.3497 2.94458 15.0722 5.66708 15.0722 9.03308C15.0699 9.6891 14.964 10.3406 14.7583 10.9636H12.9437V5.84821L8.98369 9.8082L5.02369 5.84821V10.9636H3.2085C3.00303 10.3406 2.89729 9.68907 2.89519 9.03308C2.89519 5.66708 5.61712 2.94458 8.98312 2.94458ZM8.07638 10.6986L9 11.6071L9.90731 10.6992L11.6235 8.9667V12.1842H14.1812C13.6387 13.0765 12.8755 13.8139 11.9651 14.3254C11.0547 14.837 10.0279 15.1054 8.98369 15.1047C6.78881 15.1047 4.85831 13.9336 3.78619 12.1842H6.34331V8.9667L8.07581 10.6992L8.07638 10.6986Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmr);
export default __webpack_public_path__ + "static/media/xmr.6591adf77a8c475c80f76935dcc37674.svg";
export { ForwardRef as ReactComponent };